// /ServiceExpenseRecord/index.js
import React, { useEffect, useRef } from "react";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import { ArrowLeftOutlined, PrinterOutlined } from "@ant-design/icons";
import { App, Button, Card, Flex, Grid, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import ServiceExpenseRecordFilters from "./components/ServiceExpenseRecordFilters";
import ServiceExpenseRecordTable from "./components/ServiceExpenseRecordTable"; // ✅ use correct table
import { deleteServiceExpense, fetchServiceExpenseRecord } from "./ServiceExpenseRecordThunk";
import ReportDom from "../../../../components/common/ReportDom";
import { useReactToPrint } from "react-to-print";

const { Title } = Typography;

const ServiceExpenseRecord = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { message } = App.useApp();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  // 👇 pull data safely (avoid destructuring undefined)
  const serviceExpenseRecordState = useSelector((state) => state.serviceExpenseRecord) || {};
  const { filters = {}, list = [] } = serviceExpenseRecordState;

  useEffect(() => {
    dispatch(fetchServiceExpenseRecord({})); // initial load
  }, [dispatch]);

  const reportRef = useRef(null);

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Service Expense Report",
    removeAfterPrint: true,
  });

  const handleDelete = async (id) => {
  const result = await Swal.fire({
    title: "Are you sure?",
    text: "This service expense will be deleted",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, delete",
    cancelButtonText: "Cancel",
  });
  if (!result.isConfirmed) return;
  try {
    const res = await dispatch(deleteServiceExpense(id)).unwrap();
    await Swal.fire("Deleted!", res.message, "success");
    dispatch(fetchServiceExpenseRecord({}));
  } catch (err) {
    Swal.fire("Error", err?.message || "Delete failed", "error");
  }
};

  return (
    <div className="p-4">
      <App>
        <Card
          className="shadow-md rounded-xl mb-4"
          title={
            <Flex align="center">
              <Button
                type="text"
                icon={<ArrowLeftOutlined style={{ fontSize: 18 }} />}
                onClick={() => navigate(-1)}
                style={{ marginRight: 8, padding: 0, height: "auto", lineHeight: "1", color: "#000" }}
                data-testid="service-expense-record-back-button"
              />
              <Title level={4} style={{ margin: 0 }}>Service Expense Record</Title>
            </Flex>
          }
          extra={
            <Button type="primary" icon={<PrinterOutlined />} onClick={handlePrint}>
              { !screens.xs && "Print" }
            </Button>
          }
          styles={{
            header: { borderBottom: "none", padding: "12px 16px" },
            body: { padding: 0 },
          }}
        />

        <ServiceExpenseRecordFilters messageApi={message} />

        <Card className="shadow-md rounded-xl">
          <ServiceExpenseRecordTable handleDelete={handleDelete}/>
        </Card>
      </App>

      {/* Hidden print layout */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <ReportDom
          ref={reportRef}
          title="Service Expense Report"
          filters={filters}
          renderTable={() => <ServiceExpenseRecordTable printMode={true} />}
        />
      </div>
    </div>
  );
};

export default ServiceExpenseRecord;
